import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useTranslation } from 'next-i18next';
import { Body } from '../../../../../../../../components/HotelDetailsOverlay/components/RatingSection/components/Reviews/components/ReviewCategory/components/Body.js';
import { useRating } from '../../../../../../../../components/HotelDetailsOverlay/hooks/useRating.js';
import { LabelMediumBold, ParagraphMedium, RatingBar, Stack } from '../../../../../../../../primitives/index.js';
const MAX_STATEMENTS_TO_SHOW = 2;
export const ReviewCategory = ({
  title,
  score,
  reviewCount,
  statements
}) => {
  const {
    t
  } = useTranslation();
  const formatScore = useRating();
  const {
    sentiment,
    scoreFormatted
  } = formatScore(score);
  return _jsxs(Stack, {
    spacing: 0.75,
    children: [_jsx(LabelMediumBold, {
      children: title
    }), _jsxs(Body, {
      children: [_jsx(RatingBar, {
        sentiment: sentiment,
        value: score,
        score: scoreFormatted,
        description: t('hotelDetailsOverlay:ratingSection.ratingBarDescription', {
          count: reviewCount
        })
      }), statements && statements.length > 0 && _jsx(Stack, {
        as: "ul",
        spacing: "small",
        children: statements.slice(0, MAX_STATEMENTS_TO_SHOW).map(({
          text
        }, index) => _jsx("li", {
          children: _jsx(ParagraphMedium, {
            as: "q",
            fontStyle: "italic",
            children: text
          })
        }, index))
      })]
    })]
  });
};